import React, { useContext } from 'react';
import { LocalizationContext } from '../../../context/localizationContext';
import Styles from './FittingRecommendationsListItem.module.scss';

const FittingRecommendationsListItem = (props) => {
  const { recommendation } = props;
  const { localizationState } = useContext(LocalizationContext);
  const { localization } = localizationState;
  const { webFitResults } = localization;

  const renderClubList = (clubList, clubType) => {
    return clubList
      ?.map((clubItem) => {
        if (clubType === 'wedge') {
          return clubItem.name.full.toUpperCase();
        }
        return clubItem.club?.toUpperCase();
      })
      .join(', ');
  };

  const renderRecommendationInfo = (rec) => {
    const recommendationType = {
      driver: (
        <>
          <span>
            <span className={Styles.recInfoLabel}>{webFitResults.loft}: </span>
            <span className={Styles.recInfoValue}>{rec.loft?.name?.full}</span>
          </span>
          <span className={Styles.separator}></span>
          <span>
            <span className={Styles.recInfoLabel}>{webFitResults.shaft}: </span>
            <span className={Styles.recInfoValue}>{rec.shaft?.modelName}</span>
          </span>
        </>
      ),
      fairway: (
        <>
          <span className={Styles.recInfoLabel}>{webFitResults.clubs}: </span>
          <span className={Styles.recInfoValue}>
            {renderClubList(rec?.clubs, rec.type)}
          </span>
          <span className={Styles.separator}></span>
          <span>
            <span className={Styles.recInfoLabel}>{webFitResults.shaft}: </span>
            <span className={Styles.recInfoValue}>{rec.shaft?.modelName}</span>
          </span>
        </>
      ),
      hybrid: (
        <>
          <span className={Styles.recInfoLabel}>{webFitResults.clubs}: </span>
          <span className={Styles.recInfoValue}>
            {renderClubList(rec?.clubs, rec.type)}
          </span>
        </>
      ),
      iron: (
        <span>
          <span className={Styles.recInfoLabel}>
            {webFitResults.setMakeup}:{' '}
          </span>
          <span className={Styles.recInfoValue}>
            {renderClubList(rec?.clubs, rec.type)}
          </span>
        </span>
      ),
      crossover: (
        <>
          <span className={Styles.recInfoLabel}>{webFitResults.clubs}: </span>
          <span className={Styles.recInfoValue}>
            {renderClubList(rec?.clubs, rec.type)}
          </span>
        </>
      ),
      wedge: (
        <>
          <span>
            <span className={Styles.recInfoLabel}>{webFitResults.clubs}: </span>
            <span className={Styles.recInfoValue}>
              {renderClubList(rec?.lofts, rec.type)}
            </span>
          </span>
          <span className={Styles.separator}></span>
          <span>
            <span className={Styles.recInfoLabel}>{webFitResults.shaft}: </span>
            <span className={Styles.recInfoValue}>{rec.shaft?.modelName}</span>
          </span>
        </>
      ),
      chipr: (
        <span>
          <span className={Styles.recInfoLabel}>{webFitResults.shaft}: </span>
          <span className={Styles.recInfoValue}>{rec.shaft?.modelName}</span>
        </span>
      ),
      putter: (
        <>
          <span>
            <span className={Styles.recInfoLabel}>
              {webFitResults.strokeType}:{' '}
            </span>
            <span className={Styles.recInfoValue}>
              {rec.strokeType && rec.strokeTypeName}
            </span>
          </span>
          <span className={Styles.separator}></span>
          <span>
            <span className={Styles.recInfoLabel}>
              {webFitResults.length}:{' '}
            </span>
            <span className={Styles.recInfoValue}>{rec.Length}</span>
          </span>
        </>
      ),
    };

    if (recommendationType[rec.type]) {
      return recommendationType[rec.type];
    }

    return '';
  };

  const getRecommendationItem = () => {
    return (
      <div className={Styles.item}>
        <div className={Styles.itemContent}>
          <div className={Styles.recommendationImageContainer}>
            <img
              className={`${Styles.recommendationImage} ${
                recommendation?.more_details_link ? Styles.cursor : ''
              }`}
              onClick={() => recommendation?.more_details_link !== ''
                && window.open(recommendation?.more_details_link, '__blank')
              }
              src={recommendation?.pdfImage}
              alt="Club Recommendation Image"
            />
          </div>
          <div className={Styles.recInfoContainer}>
            <div className={Styles.recType}>{recommendation?.type}</div>
            <div className={Styles.model}>{recommendation?.modelName}</div>
            <div className={Styles.recommendationInfo}>
              {renderRecommendationInfo(recommendation)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return <div>{recommendation && getRecommendationItem()}</div>;
};

export default FittingRecommendationsListItem;
